<template>
  <!-- 災害検索 -->
  <div id="AppDisasterSearch">
    <!-- 上部余白 -->
    <div style="height: 10px" />

    <!--検索条件 -->
    <div class="box" style="margin-left: 50px; margin-right: 50px">
      <template :searchConditions="searchConditions">
        <div class="columns">
          <div class="column">
            <label class="searchTitle label">災害検索</label>
          </div>
        </div>

        <!--1行目 -->
        <div class="columns">
          <div horizontal class="column is-one-third">
            <b-field label="登録期間" labelPosition="on-border">
              <b-datepicker
                v-model="searchConditions.startDate"
                name="startDate"
                placeholder="検索開始年月日"
                icon="calendar-today"
                :month-names="monthNames"
                :day-names="dayNames"
              >
                <button
                  class="button is-danger"
                  @click="(searchConditions.startDate = null)"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </button>
              </b-datepicker>
              <b-datepicker
                v-model="searchConditions.endDate"
                name="endDate"
                placeholder="検索終了年月日"
                icon="calendar-today"
                :month-names="monthNames"
                :day-names="dayNames"
              >
                <button
                  class="button is-danger"
                  @click="(searchConditions.endDate = null)"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </button>
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="災害名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.disasterName"
                name="disasterName"
                data-vv-as="災害名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="災害番号" labelPosition="on-border">
              <b-input
                v-model="searchConditions.disasterCode"
                name="disasterCode"
                data-vv-as="災害番号"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>

        <!--2行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="営業所コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.officeCode"
                name="officeCode"
                data-vv-as="営業所コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="医療機関コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalCode"
                name="hospitalCode"
                data-vv-as="医療機関コード"
                type="text"
                maxlength="8"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="医療機関名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalName"
                name="hospitalName"
                data-vv-as="医療機関名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>

        <!--3行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="対応者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffCode"
                name="staffCode"
                data-vv-as="対応者コード"
                type="text"
                maxlength="5"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="対応者名" labelPosition="on-border">
              <b-input
                name="staffName"
                v-model="searchConditions.staffName"
                data-vv-as="対応者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="緊急連絡レベル" labelPosition="on-border">
              <b-select
                v-model="searchConditions.emergencyLevel"
                expanded
              >
                <option
                  v-for="level in emergencyLevelMaster"
                  :value="level.code"
                  :key="level.code"
                >
                  {{ level.name }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>

        <!--4行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="エリア" labelPosition="on-border">
              <b-select v-model="searchConditions.area" expanded>
                <option
                  v-for="area in areaMaster"
                  :value="area.areaCode"
                  :key="area.areaCode"
                >
                  {{ area.areaName }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="ブロック" labelPosition="on-border">
              <b-select v-model="searchConditions.block" expanded>
                <option
                  v-for="block in blockMaster"
                  :value="block.blockCode"
                  :key="block.blockCode"
                >
                  {{ block.blockName }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field
              label="対応状況"
              labelPosition="on-border"
              class="checkboxButtonField"
            >
              <b-checkbox-button
                v-model="searchConditions.supportKinds"
                id="check1"
                native-value="1"
              >
                対応中
              </b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.supportKinds"
                id="check2"
                native-value="2"
              >
                対応完了
              </b-checkbox-button>
            </b-field>
          </div>
        </div>

        <!-- 検索実行ボタン -->
        <div class="columns" style="text-align: center">
          <div class="column">
            <b-button
              class="button"
              type="is-primary"
              icon-right="magnify"
              native-type="button"
              @click="search()"
            >
              検索する
            </b-button>
          </div>
        </div>
        <div class="columns" style="text-align: center">
          <div class="column">
            <span style="color: red" v-if="isSearchConditionNull">
              検索条件を指定してください。
            </span>
            <span style="color: red" v-if="isSearchConditionAll">
              全件検索となる為、検索条件を絞り込んでください。
            </span>
          </div>
        </div>
      </template>
    </div>

    <!-- 検索結果 -->
    <disasterSearchResult
      ref="searchResult"
      v-bind:search-conditions="searchConditions"
      v-bind:data="disasterResult"
      v-bind:searched="searched"
      @joined="search"
      style="margin-left: 50px; margin-right: 50px"
    />
  </div>
</template>

<script>
import AppDisasterSearchResultTemplate from "./AppDisasterSearchResult";
import * as datetime from "../utils/datetime";
import { EMERGENCY_CONTACT_LEVELS } from "../utils/patient";

export default {
  components: {
    disasterSearchResult: AppDisasterSearchResultTemplate,
  },

  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let searchConditions = {
      startDate: null,
      endDate: null,
      disasterName: "",
      disasterCode: "",
      officeCode: "",
      hospitalCode: "",
      hospitalName: "",
      staffCode: "",
      staffName: "",
      emergencyLevel: "",
      area: "",
      block: "",
      supportKinds: [],
    };
    if (this.$route.params["searchConditions"]) {
      searchConditions = this.$route.params["searchConditions"];

    } else {
      if (userInfo.roleId != 1 && userInfo.roleId != 2) {
        searchConditions.officeCode = userInfo.officeCode;
      }
    }

    let emergencyLevelMaster = JSON.parse(JSON.stringify(EMERGENCY_CONTACT_LEVELS));
    emergencyLevelMaster = [{code: null, name: ""}, ...emergencyLevelMaster];

    return {
      areaMaster: [],
      blockMaster: [],
      disasterResult: [],
      searched: false,
      searchConditions,
      isSearchConditionNull: false,
      isSearchConditionAll: false,
      monthNames: datetime.MONTHS,
      dayNames: datetime.DAYS,
      emergencyLevelMaster: emergencyLevelMaster,
    };
  },

  computed: { },

  filters: {},

  methods: {
    search: function () {
      if (
        this.searchConditions.startDate ||
        this.searchConditions.endDate ||
        this.isLength(this.searchConditions.disasterName) ||
        this.isLength(this.searchConditions.disasterCode) ||
        this.isLength(this.searchConditions.officeCode) ||
        this.isLength(this.searchConditions.hospitalCode) ||
        this.isLength(this.searchConditions.hospitalName) ||
        this.isLength(this.searchConditions.staffCode) ||
        this.isLength(this.searchConditions.staffName) ||
        this.isLength(this.searchConditions.emergencyLevel) ||
        this.isLength(this.searchConditions.area) ||
        this.isLength(this.searchConditions.block) ||
        this.searchConditions.supportKinds.length > 0
      ) {
        // 検索条件あり
        this.isSearchConditionNull = false;
        if (
          !this.searchConditions.startDate &&
          !this.searchConditions.endDate &&
          !this.isLength(this.searchConditions.disasterName) &&
          !this.isLength(this.searchConditions.disasterCode) &&
          !this.isLength(this.searchConditions.officeCode) &&
          !this.isLength(this.searchConditions.hospitalCode) &&
          !this.isLength(this.searchConditions.hospitalName) &&
          !this.isLength(this.searchConditions.staffCode) &&
          !this.isLength(this.searchConditions.staffName) &&
          !this.isLength(this.searchConditions.emergencyLevel) &&
          !this.isLength(this.searchConditions.area) &&
          !this.isLength(this.searchConditions.block)
        ) {
          if (this.isSearchAll([this.searchConditions.supportKinds.length, 2])) {
            this.isSearchConditionAll = true;
            return;
          }
        }
        this.isSearchConditionAll = false;

        // 検索実行
        this.apiCall(this.getDisastersPOST, this.getDisastersPOSTSuccess, this.getDisastersPOSTError);
      } else {
        // 検索条件未入力
        this.isSearchConditionNull = true;
        this.isSearchConditionAll = false;
      }
    },

    // エリア一覧
    getAreasGET: function (client) {
      const apiRes = client.apis.apiMaster.getAreasGET();
      return apiRes;
    },

    getAreasGETSuccess: function (result) {
      this.areaMaster = [{areaCode: "", areaName: ""}, ...result.obj];
      return;
    },

    getAreasGETError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },

    // ブロック一覧
    getBlocksGET: function (client) {
      let area = this.searchConditions.area;
      if (this.searchConditions.area == "") {
        area = null
      }
      const apiRes = client.apis.apiMaster.getBlocksGET({
        body: {
          areaCode: area,
        }
      });
      return apiRes;
    },

    getBlocksGETSuccess: function (result) {
      this.blockMaster = [{blockCode: "", blockName: ""}, ...result.obj];
      return;
    },

    getBlocksGETError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },

    // 災害検索
    getDisastersPOST: function (client) {
      const apiRes = client.apis.apiDisaster.getDisastersPOST({
        body: {
          entryDateStart: this.searchConditions.startDate,
          entryDateEnd: this.searchConditions.endDate,
          disasterName: this.searchConditions.disasterName,
          disasterId: this.searchConditions.disasterCode,
          officeCode: this.searchConditions.officeCode,
          hospitalCode: this.searchConditions.hospitalCode,
          hospitalName: this.searchConditions.hospitalName,
          supportStaffCode: this.searchConditions.staffCode,
          supportStaffName: this.searchConditions.staffName,
          emergencyLevel: this.searchConditions.emergencyLevel ? "" + this.searchConditions.emergencyLevel : "",
          areaCode: this.searchConditions.area,
          blockCode: this.searchConditions.block,
          supportStatusSummary: this.searchConditions.supportKinds
        },
      });
      return apiRes;
    },

    getDisastersPOSTSuccess: function (result) {
      this.disasterResult = result.obj;
      this.searched = true;
      return;
    },

    getDisastersPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
  },

  created: function () {
    // エリアマスタ取得
    this.apiCall(this.getAreasGET, this.getAreasGETSuccess, this.getAreasGETError);

    // ブロック一覧取得
    this.apiCall(this.getBlocksGET, this.getBlocksGETSuccess, this.getBlocksGETError);
  },

  mounted: function() {
    if (this.$route.params["searchConditions"]) {
      this.search();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AppDisasterSearch.vue